<template>
    <div class="field textarea_field">
        <div class="field_description__wrapper">
            <label :class="isFieldRequired || isRequired ? 'req' : ''" v-html="label"></label>
            <p class="field_description" v-if="description">{{ description }}</p>
        </div>
        <textarea
                v-bind="$attrs"
                :disabled="isDataUpdating"
                :value="modelValue"
                @input="$emit('update:modelValue', $event.target.value)"
                @change="$emit('onChange', $event.target.value);"
        ></textarea>
    </div>
</template>

<script>
export default {
  name: "BaseTextarea.vue",
  data() {
    return {}
  },
  mounted() {
    //this.currentValue = this.value;
  },
  props: [
    'label',
    'modelValue',
    'isRequired',
    'description',
    'rules',
    'objectKey',//Нужен для валидации
    'isFormSubmitted',
    'isDataUpdated'
  ],
  methods: {},
  computed: {
    isFieldRequired() {
      if (this.objectKey) {
        return this.$parent.isFieldRequired(this.objectKey);
      }
      return false;
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.currentValue === undefined || this.currentValue.length === 0));
    }
  }

}
</script>

<style scoped>
.field_description__wrapper {
	flex-grow: 1;
}
textarea {
	color: #000;
}
</style>